import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 48px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TogglesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 24px;
`;

export const ToggleBoxesWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const PropertyListMapWrapper = styled.div`
  gap: 16px;
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
`;

export const PropertyListWrapper = styled.div`
  display: grid;
  gap: 16px;
  --col-span: 2;
  width: 100%;
  grid-template-columns: repeat(var(--col-span), 1fr);
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    --col-span: 3;
    width: 65%;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    --col-span: 5;
  }
`;

export const MapWrapper = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 35%;
    display: flex;
    height: 450px;
  }
`;
